import { useTranslation } from "react-i18next";
import { Hideable } from "shared/UI/Hideable/Hideable";
import { useState } from "react";
import Button from "shared/UI/Buttons/Button";
import { useTrackerContext } from "core/state/TrackerContext/TrackerContext";
import { AddWaterIntakeModal } from "../AddWaterIntakeModal/AddWaterIntakeModal";
import { TrackerType } from "core/state/Trackers/TrackerType";
import { trackAddHealthData, trackCancelHealthData, trackSaveHealthData } from "core/monitoring/Events";
import { useAppReviewContext } from "core/state/AppReviewContext/AppReviewContext";

export const AddWaterIntakeCard = () => {
  const { handlePositiveMoment } = useAppReviewContext();
  const { getCurrentTrackerValue, setTrackerData: setProgress } = useTrackerContext();
  const [showAddData, setShowAddData] = useState(false);
  const { t } = useTranslation();

  function save(millilitres: number) {
    trackSaveHealthData(TrackerType[TrackerType.Water]);
    setProgress(TrackerType.Water, millilitres);
    setShowAddData(false);
    handlePositiveMoment();
  }

  const handleAddData = () => {
    trackAddHealthData(TrackerType.Water);
    setShowAddData(true);
  };

  const handleCloseModal = () => {
    trackCancelHealthData(TrackerType.Water);
    setShowAddData(false);
  };

  return (
    <>
      <Button text={t("wellbeing.trackers.buttons.addData")} onClick={handleAddData} />
      <Hideable hidden={!showAddData}>
        <AddWaterIntakeModal millilitres={getCurrentTrackerValue(TrackerType.Water)} onClose={handleCloseModal} onSave={save} />
      </Hideable>
    </>
  );
};
